export enum Direction {
    TO_YOU = 'To you',
    FROM_YOU = 'From you',
}
